import { useEffect } from 'react'

import { isNil } from 'lodash'

import { useCrudFormStore } from '@eastcoal/formily/components/CrudForm/Store/hooks/useStore'

import { ListingPickerModal } from './Modal'
import { ListingPickerHolder } from './PickerHolder'
import { ListingPickerProvider } from './Store'
import { useListingPickerStore } from './Store/hooks/useStore'

// 将选中的资源复制到表单中
const FormValuesReplicator = () => {
  const form = useCrudFormStore(state => state.form)
  const listingEntity = useListingPickerStore(state => state.listingDetail)

  useEffect(() => {
    if (isNil(listingEntity)) {
      form.reset()
    } else {
      form.setValues({ ...listingEntity, id: undefined })
    }
  }, [listingEntity])

  return null
}

export const ListingPicker = () => {
  return (
    <ListingPickerProvider>
      <ListingPickerHolder />
      <ListingPickerModal />
      <FormValuesReplicator />
    </ListingPickerProvider>
  )
}
